import request from "./request";
import { API, graphqlOperation } from "aws-amplify";
import {
  generateCoolCloudData,
  generateSharedData,
  listModelNumberByState,
  listLookupOptions,
  sendEmailNotification,
  listSdpRecipes,
  getSdpRecipe,
  listSdpRecipeInputs,
  deploySharedDataToSystems,
  listSdpUsers,
  listActionItems,
  listComments,
  getActionItems,
  insertSdpAmsData,
  generateAmsData,
  searchActionItems,
  manageEmailSesIdentity,
  listSdpAutoDeleteSchedules
} from "../graphql/queries";

import {
  createSdpRecipeInput,
  updateSdpRecipeInput,
  deleteSdpRecipeInput,
  createActionItems,
  createComment,
  deleteComment,
  updateActionItems,
  deleteActionItems
} from "../graphql/mutations";

import {
  onUpdateActionItems,
  onUpdateProduct,
  onCreateComment,
  onDeleteComment
} from "../graphql/subscriptions";

const sharedDataApi = {
  fetchUserInputs: async (params) => {
    return (await request(graphqlOperation(listSdpRecipeInputs, params)))
      .listSdpRecipeInputs;
  },
  fetchModelNumberByState: async (params) => {
    return (await request(graphqlOperation(listModelNumberByState, params)))
      .listModelNumberByState;
  },
  getRecipeTemplate: async (params) => {
    return (await request(graphqlOperation(getSdpRecipe, params))).getSdpRecipe;
  },
  listSdpUsers: async() => {
    return (await request(graphqlOperation(listSdpUsers)))
      .listSdpUsers;
  },
  listSdpRecipes: async (params) => {
    return (await request(graphqlOperation(listSdpRecipes, params)))
      .listSdpRecipes;
  },
  fetchLookupOptions: async () => {
    return (await request(graphqlOperation(listLookupOptions)))
      .listLookupOptions;
  },
  createSdUserInputs: async (params) => {
    return (await request(graphqlOperation(createSdpRecipeInput, params)))
      .createSdpRecipeInput;
  },
  updateSdUserInputs: async (params) => {
    return (await request(graphqlOperation(updateSdpRecipeInput, params)))
      .updateSdpRecipeInput;
  },
  deleteSdUserInputs: async (params) => {
    return (await request(graphqlOperation(deleteSdpRecipeInput, params)))
      .deleteSdpRecipeInput;
  },
  sendEmails: async (params) => {
    return (await request(graphqlOperation(sendEmailNotification, params)))
      .sendEmailNotification;
  },
  deploySdToSystems: async (params) => {
    return (await request(graphqlOperation(deploySharedDataToSystems, params)))
      .deploySharedDataToSystems;
  },
  generateSharedData: async function (params) {
    return (await request(graphqlOperation(generateSharedData, params)))
      .generateSharedData;
  },
  generateCoolCloudData: async function (params) {
    return (await request(graphqlOperation(generateCoolCloudData, params)))
      .generateCoolCloudData;
  },
  createActionItem: async function (params) {
    return (await request(graphqlOperation(createActionItems, params)))
      .createActionItems
  },
  updateActionItems: async function (params) {
    return (await request(graphqlOperation(updateActionItems, params)))
      .updateActionItems
  },
  deleteActionItem: async function (params) {
    return (await request(graphqlOperation(deleteActionItems, params)))
      .deleteActionItems;
  },
  listActionItems: async function (params) {
    return (await request(graphqlOperation(listActionItems, params)))
      .listActionItems
  },
  listComments: async function (params) {
    return (await request(graphqlOperation(listComments, params)))
    .listComments
  },
  createComment: async function (params) {
    return (await request(graphqlOperation(createComment, params)))
    .createComment
  },
  deleteComment: async function (params) {
    return (await request(graphqlOperation(deleteComment, params)))
    .deleteComment
  },
  deleteSdpRecipeInput: async function (params) {
    return (await request(graphqlOperation(deleteSdpRecipeInput, params)))
    .deleteSdpRecipeInput
  },
  getActionItemById: async function (id) {
    return (await request(graphqlOperation(getActionItems, { id })))
      .getActionItems;
  },
  insertSdpAmsData: async function (params) {
    return (await request(graphqlOperation(insertSdpAmsData, params)))
      .insertSdpAmsData;
  },
  generateAmsData: async function (params) {
    return (await request(graphqlOperation(generateAmsData, params)))
      .generateAmsData;
  },
  searchActionItems: async function (params) {
    return (await request(graphqlOperation(searchActionItems, params)))
      .searchActionItems;
  },
  manageEmailSesIdentity: async (params) => {
    return (await request(graphqlOperation(manageEmailSesIdentity, params)))
      .manageEmailSesIdentity;
  },

  listSdpAutoDeleteSchedules: async function (params) {
    return (await request(graphqlOperation(listSdpAutoDeleteSchedules, params)))
      .listSdpAutoDeleteSchedules;
  },

  subscribeToActionItemUpdate: (actionItemId, callback) => {
  return API.graphql(
    graphqlOperation(onUpdateActionItems, {
      filter: {
        id: { eq: actionItemId }
      }
    })
  ).subscribe({
    next: ({ value }) => {
      callback(value.data.onUpdateActionItems);
    },
    error: (error) => console.error("Subscription error:", error),
  });
},

subscribeToProductUpdate: (productId, callback) => {
  return API.graphql(
    graphqlOperation(onUpdateProduct, {
      filter: {
        id: { eq: productId }
      }
    })
  ).subscribe({
    next: ({ value }) => {
      callback(value.data.onUpdateProduct);
    },
    error: (error) => console.error("Subscription error:", error),
  });
},

subscribeToCommentUpdates: (actionId, callback) => {
  const subscription = API.graphql(
    graphqlOperation(onCreateComment, { filter: { actionId: { eq: actionId } } })
  ).subscribe({
    next: ({ value }) => {
      if (value?.data?.onCreateComment) {
        callback(value.data.onCreateComment);
      }
    },
    error: (error) => console.error("Comment subscription error:", error),
  });
  return subscription;
},

subscribeToCommentDeletes: (actionId, callback) => {
  const subscription = API.graphql(
    graphqlOperation(onDeleteComment, { filter: { actionId: { eq: actionId } } })
  ).subscribe({
    next: ({ value }) => {
      if (value?.data?.onDeleteComment) {
        callback(value.data.onDeleteComment);
      }
    },
    error: (error) => console.error("Comment delete subscription error:", error),
  });
  return subscription;
},

};

export default sharedDataApi;
